import React, { useState, useContext } from "react";

import { CustomModal } from "../../../components/CustomModal";
import InfoModal from "./modals/expertinfoModal/infoModal";
import NameModal from "./modals/expertModal/nameModal";
import ExpertDataContext from "../../../context/expertDataContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateExpert } from "../../../service/api";

function ExpertInfo(data) {
  const queryClient = useQueryClient();
  const { expertData, resetExpertDataContext } = useContext(ExpertDataContext);

  const [openNameModal, setOpenNameModal] = useState(false);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [openInfoMiniModal, setOpenInfoMiniModal] = useState(false);
  const [loading,setLoading] = useState()
  

  const name = data?.info?.firstName + " " + data?.info?.lastName;
  const degreeId = data?.info?.academicDegree?.id;
  const degree = data?.info?.academicDegree?.name;
  const field = data?.info?.academicField?.name;
  const expertCode = data?.info?.expertCode;
  const engineeringSystemNumber = data?.info?.engineeringSystemNumber;
  const city = data?.info?.city;
  const province = data?.info?.province;
  const info = data?.info;

  let w = document.documentElement.clientWidth || window.innerWidth;

  const modalHandler = () => {
    resetExpertDataContext()
    if (w > 640) {
      setOpenInfoModal(true);
    } else if (w <= 640) {
      setOpenInfoMiniModal(true);
    }
  };

  const mutation = useMutation(updateExpert, {
    onSuccess: () => {
      queryClient.invalidateQueries(["expertData"]);
      setOpenInfoModal(false);
      setOpenInfoMiniModal(false);
      setOpenNameModal(false);
      setLoading(false)
    },
    onMutate:()=>{
      setLoading(true)
    }
  });

  const onOk = () => {
    mutation.mutate(expertData);
  };

  return (
    <div
   
      className="w-full relative"
      
    >

      <div
      
        
        className="font-body flex flex-row bg-white rounded-xl py-4 justify-center gap-[6rem] max-lg:px-4 hover:brightness-90 hover:cursor-pointer hover:shadow-lg  text-base whitespace-nowrap max-lg:flex-col max-lg:gap-5"
      >
        <div
          onClick={()=>setOpenNameModal(true)}
          className=" flex-col gap-1 text-right hidden max-lg:flex"
        >
          <div className="flex flex-row gap-1 min-w-">
            <p hidden={degreeId === 1 ? false : true}>دکتر</p>
            <p>{name}</p>
          </div>
          <p className="max-lg:text-[0.875rem] text-[#009538]">
            {degree} {field}
          </p>
        </div>

        <div onClick={modalHandler} className="flex flex-row gap-1 ">
          <p className="font-bold text-[0.75rem]">استان و شهر:</p>
          <p className="max-lg:text-[0.75rem]">
            {" "}
            {province}/{city}
          </p>
        </div>
        <div onClick={modalHandler} className="flex flex-row gap-1">
          <p className="font-bold text-[0.75rem]">کد کارشناس:</p>
          <p className="max-lg:text-[0.75rem]"> {expertCode}</p>
        </div>
        <div
          onClick={modalHandler}
          className={
            engineeringSystemNumber !== null
              ? " flex-row gap-1 flex "
              : "hidden"
          }
        >
          <p className="font-bold text-[0.75rem]">کد نظام مهندسی:</p>
          <p className="max-lg:text-[0.75rem]">{engineeringSystemNumber} </p>
        </div>
      </div>
      {openInfoModal && (
        <CustomModal
          onOk={onOk}
          loading={loading}
          size={"25vw"}
          visible={openInfoModal}
          handleCancel={() => setOpenInfoModal(false)}
        >
          <InfoModal modalData={info} />
        </CustomModal>
      )}

      {openInfoMiniModal && (
        <CustomModal
        loading={loading}
          onOk={onOk}
          size={"100vw"}
          visible={openInfoMiniModal}
          handleCancel={() => setOpenInfoMiniModal(false)}
        >
          <InfoModal modalData={info} />
        </CustomModal>
      )}

      {openNameModal && (
        <CustomModal
        loading={loading}
          onOk={onOk}
          size={"100vw"}
          visible={openNameModal}
          handleCancel={() => setOpenNameModal(false)}
        >
          <NameModal modalData={info} size={"100%"} />
        </CustomModal>
      )}
    </div>
  );
}

export default ExpertInfo;
